'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { getFullUrl } from 'hubspot-url-utils';
import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
import QuickFetch from 'quick-fetch';
import Superstore, { IndexedDB } from 'superstore';
import * as api from 'laboratory-lib/core/api';
import * as client from 'laboratory-lib/client';
let defaultStore;

try {
  defaultStore = new Superstore({
    backend: IndexedDB,
    namespace: 'laboratory'
  });
} catch (err) {
  /* NOOP */
}

export function createClient(_ref = {}) {
  let {
    apiDomain = getFullUrl('api'),
    http = noAuthApiClient,
    onError = api.reportError,
    quickFetch = QuickFetch,
    store = defaultStore,
    timeout = 8000
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["apiDomain", "http", "onError", "quickFetch", "store", "timeout"]);

  return client.createClient(Object.assign({
    apiDomain,
    http,
    onError,
    quickFetch,
    store,
    timeout
  }, rest));
}